import { Option } from 'coreOld/types';
import { USER_STATUSES_LABEL } from 'system/constants';
import { UserStatuses } from 'system/enums';

export const getUserStatusOptions = (): Option[] =>
  Object.values(UserStatuses).map((status) => ({
    value: status,
    label: USER_STATUSES_LABEL[status],
  }));
